/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Auth_HeadingInputs */

const en_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to register`)
};

const es_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para registrarte`)
};

const de_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich an, um teilzunehmen`)
};

const zh_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后报名`)
};

const ar_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول للتسجيل`)
};

const fr_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour vous inscrire`)
};

const vi_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để đăng ký`)
};

const sw_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia ili kujisajili`)
};

const th_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบเพื่อลงทะเบียน`)
};

const bs_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavite se da se registrujete`)
};

const ja_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインして申し込む`)
};

const ko_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인하고 등록하기`)
};

const pt_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para se inscrever`)
};

const it_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per registrarti`)
};

const sv_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in för att anmäla dig`)
};

const nl_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in om je in te schrijven`)
};

const da_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind for at tilmelde dig`)
};

const nb_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn for å melde deg på`)
};

const fi_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään ilmoittautuaksesi`)
};

const pl_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby się zarejestrować`)
};

const ru_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы зарегистрироваться`)
};

const tr_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıt olmak için giriş yapın`)
};

const hi_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंजीकरण के लिए साइन इन करें`)
};

const id_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk mendaftar`)
};

const ms_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk mendaftar`)
};

const cs_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlaste se k registraci`)
};

const el_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συνδεθείτε για να εγγραφείτε`)
};

const he_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היכנסו כדי להירשם`)
};

const af_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld aan om te registreer`)
};

const hu_events_auth_heading = /** @type {(inputs: Events_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bejelentkezés a regisztrációhoz`)
};

/**
* | output |
* | --- |
* | "Sign in to register" |
*
* @param {Events_Auth_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_auth_heading = /** @type {((inputs?: Events_Auth_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Auth_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_auth_heading(inputs)
	if (locale === "de") return de_events_auth_heading(inputs)
	if (locale === "zh") return zh_events_auth_heading(inputs)
	if (locale === "ar") return ar_events_auth_heading(inputs)
	if (locale === "fr") return fr_events_auth_heading(inputs)
	if (locale === "vi") return vi_events_auth_heading(inputs)
	if (locale === "sw") return sw_events_auth_heading(inputs)
	if (locale === "th") return th_events_auth_heading(inputs)
	if (locale === "bs") return bs_events_auth_heading(inputs)
	if (locale === "ja") return ja_events_auth_heading(inputs)
	if (locale === "ko") return ko_events_auth_heading(inputs)
	if (locale === "pt") return pt_events_auth_heading(inputs)
	if (locale === "it") return it_events_auth_heading(inputs)
	if (locale === "sv") return sv_events_auth_heading(inputs)
	if (locale === "nl") return nl_events_auth_heading(inputs)
	if (locale === "da") return da_events_auth_heading(inputs)
	if (locale === "nb") return nb_events_auth_heading(inputs)
	if (locale === "fi") return fi_events_auth_heading(inputs)
	if (locale === "pl") return pl_events_auth_heading(inputs)
	if (locale === "ru") return ru_events_auth_heading(inputs)
	if (locale === "tr") return tr_events_auth_heading(inputs)
	if (locale === "hi") return hi_events_auth_heading(inputs)
	if (locale === "id") return id_events_auth_heading(inputs)
	if (locale === "ms") return ms_events_auth_heading(inputs)
	if (locale === "cs") return cs_events_auth_heading(inputs)
	if (locale === "el") return el_events_auth_heading(inputs)
	if (locale === "he") return he_events_auth_heading(inputs)
	if (locale === "af") return af_events_auth_heading(inputs)
	if (locale === "hu") return hu_events_auth_heading(inputs)
	return en_events_auth_heading(inputs)
});